import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const Titulo = ({ texto = "Sin Título", color = "#1976d2", fontSize, buttonConfig }) => (

  <Box className="box-contenido-alineado-izquierda">
    <Typography
      variant="h1"
      gutterBottom
      role="heading"
      aria-level={1}
      sx={{
        color: color,
        fontWeight: "bold",
        fontSize: fontSize || "inherit",
      }}
    >
      {texto}
    </Typography>
    {buttonConfig?.showButton && (
      <Button
        variant="contained"
        color={buttonConfig.color || "primary"}
        size="small"
        startIcon={<AddIcon />}
        onClick={buttonConfig.onClick}
      >
        {buttonConfig.text || ""}
      </Button>
    )}
  </Box>
);

Titulo.propTypes = {
  texto: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.string,
  buttonConfig: PropTypes.shape({
    showButton: PropTypes.bool, // Indica si se debe mostrar el botón
    text: PropTypes.string, // Texto del botón
    color: PropTypes.string, // Color del botón
    onClick: PropTypes.func, // Función a ejecutar al hacer clic
  }),
};

export default Titulo;

// import React from "react";
// import PropTypes from "prop-types";
// import { Box, Typography } from "@mui/material";

// const Titulo = ({ texto = "Sin Título" }) => (
//   <Box
//     display="flex"
//     justifyContent="left"
//     alignItems="center"
//     sx={{
//       my: 2,
//       ml: 2
//     }}
//   >
//     <Typography
//       variant="h4"
//       gutterBottom
//       sx={{
//         color: "#1976d2",
//         fontWeight: "bold",
//       }}
//     >
//       {texto}
//     </Typography>
//   </Box>
// );

// Titulo.propTypes = {
//   texto: PropTypes.string,
// };

// export default Titulo;
